/**
 * LogoutConfirmDialog — explicit confirmation before tearing down the
 * session (UX-15). Avoids accidental logouts from misclicks in the user
 * dropdown.
 */
import React from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';
import { LogOut } from 'lucide-react';

const LogoutConfirmDialog = ({ open, onOpenChange, onConfirm }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="logout-confirm-dialog" className="max-w-sm">
      <AlertDialogHeader>
        <div className="mx-auto bg-stone-100 text-stone-700 rounded-full p-2.5 w-fit">
          <LogOut className="h-5 w-5" />
        </div>
        <AlertDialogTitle className="text-center font-display">
          Se déconnecter ?
        </AlertDialogTitle>
        <AlertDialogDescription className="text-center">
          Vous serez redirigé vers la page d&apos;accueil. Vos brouillons
          d&apos;annonces resteront sauvegardés sur votre compte.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="sm:justify-center gap-2">
        <AlertDialogCancel data-testid="logout-cancel-btn">
          Annuler
        </AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-stone-900 hover:bg-stone-800 text-white"
          data-testid="logout-confirm-btn"
        >
          Se déconnecter
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default LogoutConfirmDialog;
